import { observer } from "mobx-react";
import React, { useState } from "react";
import { GetAChannel } from "../../stores/GetAChannel";
import {
  Paper,
  Title,
  Textarea,
  CopyButton,
  Button,
  Text,
  Stack,
  AspectRatio,
  Group,
} from "@mantine/core";
import { IconCopy, IconQrcode } from "@tabler/icons-react";
import { QRCodeSVG } from "qrcode.react";

const ConnectToNode: React.FC<{ getAChannel: GetAChannel }> = observer(
  ({ getAChannel }) => {
    const [showQRCode, setShowQRCode] = useState(false);

    const isMainnet = getAChannel.selectedNetwork === "Mainnet";

    const nodeAddress = isMainnet
      ? "038a9e56512ec98da2b5789761f7af8f280baf98a09282360cd6ff1381b5e889bf@64.23.162.51:9735"
      : "03e30fda71887a916ef5548a4d02b06fe04aaa1a8de9e24134ce7f139cf79d7579@64.23.192.68:9736";

    const torAddress =
      "038a9e56512ec98da2b5789761f7af8f280baf98a09282360cd6ff1381b5e889bf@y4u5v6vqenjr4wlnpcp4ekftpyfrsu2sewcrzcl7ob2lctwqcvqpocid.onion:9735";

    return (
      <Paper withBorder p="md">
        <Stack>
          <Text>
            {" "}
            Please copy or scan our node's address. Your node should have a
            "connect to peer" button. Use that to connect to Megalith LSP.
          </Text>

          <Group align="center">
            <CopyButton value={nodeAddress}>
              {({ copied, copy }) => (
                <Button leftSection={<IconCopy />} onClick={copy}>
                  {copied ? "Copied!" : "Copy Clearnet Address"}
                </Button>
              )}
            </CopyButton>
            {isMainnet && (
              <CopyButton value={torAddress}>
                {({ copied, copy }) => (
                  <Button
                    size="xs"
                    variant="outline"
                    leftSection={<IconCopy />}
                    onClick={copy}
                  >
                    {copied ? "Copied!" : "Copy Tor Address"}
                  </Button>
                )}
              </CopyButton>
            )}
          </Group>
          {/* <Button
            variant="outline"
            leftSection={<IconQrcode />}
            onClick={() => setShowQRCode(!showQRCode)}
          >
            {showQRCode ? "Hide QR Code" : "Our Address (QR Code)"}
          </Button> */}
          {/* {showQRCode && (
            <Group justify="center" align="flex-start">
              <Stack align="center" gap="xs">
                <Text fw={500}>Clearnet Address</Text>
                <AspectRatio ratio={1} style={{ width: 260 }}>
                  <QRCodeSVG
                    value={nodeAddress}
                    title="Clearnet Address QR Code"
                    size={260}
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    level={"L"}
                    marginSize={6}
                  />
                </AspectRatio>
              </Stack>
              {isMainnet && (
                <Stack align="center" gap="xs">
                  <Text fw={500}>Tor Address</Text>
                  <AspectRatio ratio={1} style={{ width: 260 }}>
                    <QRCodeSVG
                      value={torAddress}
                      title="Tor Address QR Code"
                      size={260}
                      bgColor={"#ffffff"}
                      fgColor={"#000000"}
                      level={"L"}
                      marginSize={6}
                    />
                  </AspectRatio>
                </Stack>
              )}
            </Group>
          )} */}
          <Text>
            Use the "connect to peer" (or similar) button on your Lightning
            Node....
          </Text>
          <Text>... OK! Are you sure you have connected to Megalith LSP?</Text>
          <Button
            onClick={() => getAChannel.setuserHasConfirmedIsConnected(true)}
          >
            Yes, I've Added Megalith LSP as a Peer
          </Button>
        </Stack>
      </Paper>
    );
  }
);

export default ConnectToNode;
